import { NavigationStart, Router, RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { authGuard, authGuardChild } from './shared/guards/auth.guard';
import { RedirectService } from './shared/services/redirect-service';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { PermissionGuard } from './shared/guards/permission.guard';
const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [PermissionGuard],
    loadChildren: () =>
      import('./layout/default-layout/default-layout.module').then(
        m => m.DefaultLayoutModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./layout/auth-layout/auth-layout.module').then(
        m => m.AuthLayoutModule
      ),
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(
    private router: Router,
    private redirectService: RedirectService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (
          event.navigationTrigger === 'imperative' &&
          event.restoredState == null &&
          event.url !== '/auth' // To exclude authentication-related routes
        ) {
          this.redirectService.setRedirectUrl(event.url || '/welcome');
        }
      }
    });
  }
}
